/**
 * Liga o painel "Usuários e permissões" da Secretaria (rota e itens de menu). Desligado, a rota
 * responde 404 e o menu não mostra o item.
 *
 * Existe porque, até a Parte 2 do backend, as rotas da Secretaria ainda não exigem as permissões:
 * o painel grava de verdade, mas desmarcar uma ação não bloqueia nada — em produção seria um
 * controle de acesso que parece funcionar e não funciona (SEC-01 da review da #1354).
 *
 * Função, e não constante de módulo, para o teste alternar a flag com `vi.stubEnv`.
 *
 * TODO(17tpepcgarq): ligar em produção quando a Parte 2 migrar as rotas para as permissões, e
 * depois apagar esta função e as checagens dela.
 */
export const painelPermissoesSecretariaHabilitado = (): boolean =>
  process.env.NEXT_PUBLIC_SECRETARIA_PERMISSOES_ENABLED === 'true';
